<script lang="ts" setup>
import { useEvents } from '~/composables/event-drawing-lots/use-events'

const props = defineProps({
  width: {
    type: [String, Number],
    default: 448,
  },
})

const { isMobile } = useDevice()
const { isVisibleWelcomePopup, redirectToEvent, closePopup } =
  useEvents()
const isVisible = computed(() => isVisibleWelcomePopup.value)
</script>
<template>
  <VDialog
    v-model="isVisible"
    :width="props.width"
    content-class="base-modal event-welcome-modal"
    :persistent="true"
    opacity="0.8"
    no-click-animation
  >
    <VCard>
      <div class="event-welcome-modal__content cursor-pointer">
        <VBtn
          class="event-welcome-modal__close"
          icon="icon-close-popup"
          variant="text"
          size="small"
          @click="closePopup"
        />
        <img
          :src="
            isMobile
              ? '/images/event-drawing-lots/popup-mb.webp'
              : '/images/event-drawing-lots/popup.webp'
          "
          alt="event popup"
          @click="redirectToEvent"
        />
      </div>
    </VCard>
  </VDialog>
</template>
<style lang="scss" scoped>
@import '~/assets/styles/components/event-drawing-lots/event-modal.scss';
</style>
